"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ozzano-dell-emilia": {
    "6705bde0": [{
      "hkey": "ba6ebb10",
      "slug": "noce",
      "name": "Noce",
      "primary": true,
      "skipSearch": false
    }],
    "noce-di-mercatale": [{
      "hkey": "ba6ebb10",
      "slug": "noce",
      "name": "Noce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;